// @flow
import styled from 'styled-components';

export const TradeTitleWrapper = styled.div`
	height: 60px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 20px;
	border: 1px solid #F6F6F6;
`;

export default TradeTitleWrapper;


// WEBPACK FOOTER //
// ./src/pages/league/transactions/tradeTitleWrapper.js